import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../services/app.service';

@Component({
  selector: 'app-userheader',
  templateUrl: './userheader.component.html',
  styleUrls: ['./userheader.component.scss']
})
export class UserheaderComponent implements OnInit {

  userDetails: any;
  constructor(private router: Router, private appService: AppService) { }

  ngOnInit(): void {
    if (sessionStorage.getItem('currentUser')) {
      this.userDetails = JSON.parse(sessionStorage.getItem('currentUser') || '{}');
    }
  }
  LogOut() {
    sessionStorage.removeItem('currentUser');
    this.appService.changeUserHeader(0);
    this.router.navigate(['/login']);
  }

}
